import React, { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { FormButton, getAuthorities, redirectToPages } from "../../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../../_metronic/_partials/controls";
import { InterviewsFilter } from "./interviews-filter/InterviewsFilter";
import { InterviewsTable } from "./interviews-table/InterviewsTable";
import { useInterviewsUIContext } from "./InterviewsUIContext";

export function InterviewsCard() {
  // Interviews UI Context
  const interviewsUIContext = useInterviewsUIContext();
  const interviewsUIProps = useMemo(() => {
    return {
      openNewInterviewModal: interviewsUIContext.openNewInterviewModal,
    };
  }, [interviewsUIContext]);
    
  // Getting curret state of Interview list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.studentPreInterviews }),
    shallowEqual
  );
  const { isSuccess, type, authorities } = currentState;

  // Authority Parameters
  const { isAdditionAuthorized } = getAuthorities(authorities);
  
  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Card>
      <CardHeader title="Görüşme Listesi">
        {
          isAdditionAuthorized &&
          <CardHeaderToolbar>
            <FormButton 
              path="Navigation/Plus"
              title="Yeni Görüşme"
              method={interviewsUIProps.openNewInterviewModal}
            />
          </CardHeaderToolbar>
        }        
      </CardHeader>
      <CardBody>
        <InterviewsFilter />
        <InterviewsTable />
      </CardBody>
    </Card>
  );
}